import React from 'react';
import Footer from '../components/Footer';
import Anjali from '../Team/Anjali.jpg.jpeg';
import Garima from '../Team/Garima.jpg.jpeg';
import Nishi from '../Team/Nishi.jpg.jpeg';
import Preeti from '../Team/Preeti.jpg.jpeg';
import Priya from '../Team/Priya.jpg.jpeg';
import Santosh from '../Team/Santosh.jpg.jpeg';
import Shivani from '../Team/Shivani.jpg.jpeg';
import Vaibhav from '../Team/Vaibhav.jpg.jpeg';
import laxmi from '../Team/laxmi.jpg';
import alisa from '../Team/alisa.jpg';

const OurMember = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Preeti Singh',
      designation: 'Branch Manager',
      bio: `Preeti is an accomplished and result-oriented Branch Manager with over 12 years of extensive experience in sales and business development. She brings strong expertise in driving revenue growth, managing branch operations, and leading high-performing teams. With a strategic mindset and excellent leadership skills, Preeti has consistently delivered outstanding results while ensuring operational efficiency and customer satisfaction. She plays a vital role in strengthening business performance and fostering a culture of accountability and excellence within the organization. She has completed her education from Chhatrapati Shahu Ji Maharaj University and is married.

Message :
"Sustained success comes from strong leadership, clear vision, and disciplined execution. As a team, we must stay committed to our goals, maintain high standards of performance, and continuously adapt to evolving challenges. I believe in empowering individuals, driving accountability, and building a culture of excellence where every effort contributes to collective success. Let's work together with focus and determination to achieve greater milestones."`,
      image: Preeti,
      category: 'Leadership'
    },
    {
      id: 10,
      name: 'Alisha Bhadani',
      designation: 'Legal Analyst',
      bio: `Alisha Bhadani is a dedicated legal professional and Advocate with a strong academic background, holding a BBA LL.B degree from Bharati Vidyapeeth and a Diploma in Cyber Law from Mumbai Law College. With over five years of professional experience in the paralegal and insurance law sector, she has developed sound expertise in legal documentation, case management, compliance matters, and insurance-related legal issues. Known for her commitment, analytical skills, and client-focused approach, she combines legal knowledge with practical industry experience to deliver effective and reliable legal solutions.

Message :
"Legal excellence is built on precision, integrity, and a deep understanding of both the law and the client's needs. I believe in providing clear, actionable legal guidance that protects interests while enabling progress. Let's continue to uphold the highest standards of professionalism and deliver value through sound legal counsel."`,
      image: alisa,
      category: 'Leadership'
    },
    {
      id: 2,
      name: 'Garima Trivedi',
      designation: 'HR  Manager',
      bio: `Garima Trivedi is an experienced HR professional with over 4+ years of dedicated experience in human resource management. She specializes in talent acquisition, employee engagement, and organizational development. With a strong understanding of HR practices and people management, Garima plays a key role in building a positive workplace culture and supporting the company's growth through effective workforce strategies. She holds an MBA in Human Resource Management from Lucknow University and is married.

💬 Message :
"I believe that people are the greatest strength of any organization. My goal is to create a supportive, inclusive, and motivating work environment where everyone feels valued and empowered to grow. Let's continue to collaborate, learn from each other, and achieve new milestones together as a strong and united team."`,
      image: Garima,
      category: 'Leadership'
    },
    {
      id: 3,
      name: 'Priya Singh',
      designation: 'Team Manager',
      bio: `Priya is a dynamic and result-driven Team Manager with over 6+ years of experience in sales and team handling. She specializes in driving team performance, achieving business targets, and building strong customer relationships. With excellent leadership, communication, and strategic planning skills, Priya plays a key role in motivating her team, improving productivity, and ensuring consistent growth. She has completed her graduation from Dr. Ram Manohar Lohia Avadh University, which has helped her build a strong foundation in her professional journey. Priya is currently single and highly focused on her career growth and leadership development.

Message :
"I believe a strong team is built on trust, consistency, and shared goals. My aim is to guide and support each team member to achieve their best potential. Let's stay focused, work together, and continuously push our limits to achieve greater success as a team."`,
      image: Priya,
      category: 'Leadership'
    },
    {
      id: 4,
      name: 'Laxmi Kumari',
      designation: 'Retention Manager',
      bio: `Laxmi Kumari is a dedicated and customer-focused Retention Manager with expertise in building strong client relationships and ensuring customer satisfaction. She specializes in retention strategies, customer engagement, and loyalty programs. With excellent communication and problem-solving skills, Laxmi plays a crucial role in maintaining long-term client relationships and reducing churn rates. Her commitment to understanding customer needs and delivering exceptional service makes her an invaluable asset to the organization.

Message :
"Customer satisfaction is the key to long-term success. I believe in building genuine relationships, understanding client needs, and going the extra mile to ensure their happiness. Let's work together to create lasting impressions and turn our customers into our biggest advocates."`,
      image: laxmi,
      category: 'Operations'
    },
    {
      id: 7,
      name: 'Anjali Chauhan',
      designation: 'Team Leader',
      bio: `Anjali Chauhan is an enthusiastic and result-oriented Team Leader with 3 years of experience in sales. She has demonstrated strong capabilities in handling team responsibilities, achieving targets, and maintaining effective customer relationships. With a proactive approach and good communication skills, Anjali focuses on improving team performance, ensuring productivity, and contributing to overall business growth. Her dedication and willingness to learn help her adapt quickly and deliver consistent results in a competitive environment.

Message :
"Growth begins with the right mindset and consistent effort. Let's stay focused on our goals, support each other, and keep pushing our limits to achieve better results every day. Together, we can build a strong, motivated, and high-performing team."`,
      image: Anjali,
      category: 'Team Leaders'
    },
    {
      id: 8,
      name: 'Shivani Chaturvedi',
      designation: 'Team Leader',
      bio: `Shivani Chaturvedi is a dedicated and performance-driven Team Leader with 4 years of experience in sales and team management. She has developed strong expertise in driving team performance, achieving sales targets, and building effective customer relationships. With excellent communication, leadership, and problem-solving skills, Shivani plays a key role in guiding her team, improving productivity, and ensuring consistent business growth. Her ability to motivate team members and maintain a results-oriented approach makes her a valuable contributor to organizational success.

Message :
"Success in sales comes from consistency, teamwork, and a strong focus on results. I encourage everyone to stay motivated, take ownership of their goals, and continuously strive for improvement. Together, with the right mindset and dedication, we can achieve exceptional results and grow stronger as a team."`,
      image: Shivani,
      category: 'Team Leaders'
    },
    {
      id: 9,
      name: 'Vaibhav Gupta',
      designation: 'Team Leader',
      bio: `Vaibhav Gupta is a motivated and goal-oriented Team Leader with 1+ years of experience in team handling and sales operations. He has developed strong skills in guiding team members, achieving targets, and maintaining effective coordination within the team. With a proactive approach and a focus on continuous improvement, Vaibhav works towards enhancing team productivity and delivering consistent results. His ability to adapt quickly and lead with clarity makes him a valuable contributor to the organization's growth.

Message :
"Success is built on consistency, teamwork, and a strong commitment to our goals. Let's stay focused, support one another, and keep improving every day to achieve better results together. With the right attitude and dedication, we can accomplish great milestones as a team."`,
      image: Vaibhav,
      category: 'Team Leaders'
    },
    {
      id: 5,
      name: 'Nishi Srivastava',
      designation: 'Graphic Designer',
      bio: `Nishi Srivastava is a creative and detail-oriented Graphic Designer with 3 years of experience in designing visually compelling and engaging content. She has completed her education from MAAC Animation Academy, where she built a strong foundation in design principles, animation, and digital creativity. Nishi specializes in creating impactful graphics, branding materials, and visual concepts that effectively communicate ideas and enhance brand identity. With a keen eye for aesthetics and a passion for innovation, she consistently delivers high-quality designs that align with business goals.

Message :
"Creativity is not just about design, it's about solving problems in a visually impactful way. I believe in continuous learning, experimenting with new ideas, and pushing creative boundaries. Let's collaborate, innovate, and create designs that truly make a difference."`,
      image: Nishi,
      category: 'Creative'
    },
    {
      id: 6,
      name: 'Santosh Kumar Azad',
      designation: 'Social Media Manager',
      bio: `Santosh Kumar is a skilled Social Media Manager with over 1.5 years of professional experience at Agency Bazaar and more than 4 years of overall expertise in social media content writing, SEO, and video editing. He specializes in creating engaging, audience-focused, and result-driven content that enhances brand visibility and digital growth.

With a strong command over creative storytelling, content strategy, and SEO optimization, Santosh excels at transforming ideas into compelling digital content that captures attention and drives engagement. His expertise in video editing and social media management helps brands build a strong online presence across multiple platforms.

He holds a B.Tech degree and combines technical understanding with creative communication skills, making him highly effective in today's fast-paced digital marketing environment.

Message :
"In the digital world, consistency, creativity, and data-driven decisions are the keys to success. Let's focus on building meaningful connections with our audience, staying ahead of trends, and delivering impactful content that drives engagement and growth. Together, we can create a strong and influential digital presence."`,
      image: Santosh,
      category: 'Creative'
    }
  ];

  // Reorder members - move Nishi and Santosh to the end
  const reorderedMembers = [...teamMembers];
  const nishiIndex = reorderedMembers.findIndex(m => m.id === 5);
  const santoshIndex = reorderedMembers.findIndex(m => m.id === 6);
  
  const nishi = reorderedMembers.splice(nishiIndex, 1)[0];
  const santosh = reorderedMembers.splice(santoshIndex - 1, 1)[0];
  
  reorderedMembers.push(nishi, santosh);

  return (
    <>
      {/* Hero Section */}
      <section className="team-hero">
        <div className="team-hero-overlay"></div>
        <div className="team-hero-blur-1"></div>
        <div className="team-hero-blur-2"></div>
        <div className="team-hero-blur-3"></div>

        <div className="team-container">
          <div className="team-hero-content">
            <div className="team-hero-badge">
              <span>⭐ Our Dream Team</span>
            </div>
            <h1 className="team-hero-title">
              Meet Our Team
            </h1>
            <p className="team-hero-subtitle">
              The creative minds and technical experts behind our success
            </p>
            <div className="team-hero-line"></div>
          </div>
        </div>
      </section>

      {/* Team Grid Section - 4 Columns */}
      <section className="team-grid-section">
        <div className="team-container">
          <div className="team-header">
            <span className="team-header-badge">Meet the Team</span>
            <h2 className="team-header-title">
              Our Dedicated <span className="text-gradient">Professionals</span>
            </h2>
            <p className="team-header-subtitle">
              Each team member brings unique skills and passion to create exceptional results for our clients.
            </p>
          </div>

          <div className="team-grid-4cols">
            {reorderedMembers.map((member, index) => (
              <div key={member.id} className="team-card" style={{ animationDelay: `${index * 0.05}s` }}>
                <div className="team-card-image-wrapper">
                  <div className="team-image-box">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="team-card-image"
                    />
                  </div>
                  <div className="team-card-overlay"></div>
                  <div className="team-card-badge">
                    <span>✨</span>
                  </div>
                </div>
                <div className="team-card-content">
                  <h3 className="team-card-name">{member.name}</h3>
                  <p className="team-card-designation">{member.designation}</p>
                  <div className="team-card-bio-full">
                    {member.bio.split('\n').map((paragraph, idx) => (
                      <p key={idx} className="bio-paragraph">{paragraph}</p>
                    ))}
                  </div>
                  <div className="team-card-line"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      <style jsx>{`
        /* ======================================== */
        /* DARK/LIGHT MODE VARIABLES */
        /* ======================================== */
        :root {
          --team-bg-light: #f9fafb;
          --team-bg-dark: #0f0f1a;
          --team-card-bg-light: #ffffff;
          --team-card-bg-dark: #1a1a2e;
          --team-text-primary-light: #1f2937;
          --team-text-primary-dark: #ffffff;
          --team-text-secondary-light: #6b7280;
          --team-text-secondary-dark: #a0aec0;
          --team-card-shadow-light: rgba(0, 0, 0, 0.1);
          --team-card-shadow-dark: rgba(0, 0, 0, 0.3);
          --team-badge-bg-light: linear-gradient(135deg, #e0e7ff, #fce7f3);
          --team-badge-bg-dark: linear-gradient(135deg, #1e1b4b, #4c1d95);
        }

        [data-theme="dark"] {
          --team-bg-light: #0f0f1a;
          --team-card-bg-light: #1a1a2e;
          --team-text-primary-light: #ffffff;
          --team-text-secondary-light: #a0aec0;
          --team-card-shadow-light: rgba(0, 0, 0, 0.3);
          --team-badge-bg-light: linear-gradient(135deg, #1e1b4b, #4c1d95);
        }

        /* Global Styles */
        .text-gradient {
          background: linear-gradient(135deg, #4f46e5, #ec4899);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }

        /* Hero Section */
        .team-hero {
          position: relative;
          background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
          padding: 5rem 0;
          overflow: hidden;
          color: white;
        }
        [data-theme="dark"] .team-hero {
          background: linear-gradient(135deg, #0a0a0a, #1a1a2e, #0f0c29);
        }
        .team-hero-overlay {
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at 20% 50%, rgba(79, 70, 229, 0.3), transparent);
        }
        .team-hero-blur-1 {
          position: absolute;
          top: -6rem;
          right: -6rem;
          width: 24rem;
          height: 24rem;
          background: linear-gradient(135deg, #4f46e5, #ec4899);
          opacity: 0.3;
          border-radius: 9999px;
          filter: blur(3rem);
          animation: float 6s ease-in-out infinite;
        }
        .team-hero-blur-2 {
          position: absolute;
          bottom: -6rem;
          left: -6rem;
          width: 24rem;
          height: 24rem;
          background: linear-gradient(135deg, #7c3aed, #f43f5e);
          opacity: 0.3;
          border-radius: 9999px;
          filter: blur(3rem);
          animation: float 6s ease-in-out infinite reverse;
        }
        .team-hero-blur-3 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 30rem;
          height: 30rem;
          background: radial-gradient(circle, rgba(236, 72, 153, 0.15), transparent);
          border-radius: 9999px;
          filter: blur(4rem);
        }
        .team-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 1rem;
          position: relative;
          z-index: 10;
        }
        .team-hero-content {
          text-align: center;
          max-width: 48rem;
          margin: 0 auto;
        }
        .team-hero-badge {
          display: inline-block;
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(10px);
          padding: 0.5rem 1rem;
          border-radius: 9999px;
          font-size: 0.875rem;
          margin-bottom: 1.5rem;
          border: 1px solid rgba(255,255,255,0.2);
        }
        .team-hero-title {
          font-size: 3.5rem;
          font-weight: bold;
          margin-bottom: 1.5rem;
          animation: fadeInUp 0.6s ease-out;
        }
        .team-hero-subtitle {
          font-size: 1.25rem;
          opacity: 0.9;
          margin-bottom: 1.5rem;
          animation: fadeInUp 0.6s ease-out 0.1s both;
        }
        .team-hero-line {
          width: 6rem;
          height: 0.25rem;
          background: linear-gradient(90deg, #4f46e5, #ec4899);
          margin: 1.5rem auto;
          border-radius: 9999px;
          animation: fadeInUp 0.6s ease-out 0.2s both;
        }

        /* Team Grid Section - 4 Columns */
        .team-grid-section {
          padding: 5rem 0;
          background: var(--team-bg-light);
          transition: background 0.3s ease;
        }
        .team-header {
          text-align: center;
          margin-bottom: 4rem;
        }
        .team-header-badge {
          display: inline-block;
          background: var(--team-badge-bg-light);
          color: #4f46e5;
          padding: 0.25rem 1rem;
          border-radius: 9999px;
          font-size: 0.875rem;
          font-weight: 600;
          margin-bottom: 1rem;
          transition: all 0.3s ease;
        }
        [data-theme="dark"] .team-header-badge {
          color: #a78bfa;
        }
        .team-header-title {
          font-size: 2.5rem;
          font-weight: bold;
          color: var(--team-text-primary-light);
          margin-bottom: 1rem;
          transition: color 0.3s ease;
        }
        .team-header-subtitle {
          color: var(--team-text-secondary-light);
          max-width: 42rem;
          margin: 0 auto;
          font-size: 1.125rem;
          transition: color 0.3s ease;
        }

        /* 4 Column Grid */
        .team-grid-4cols {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
        }

        /* Team Card */
        .team-card {
          background: var(--team-card-bg-light);
          border-radius: 1.5rem;
          overflow: hidden;
          box-shadow: 0 20px 25px -12px var(--team-card-shadow-light);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          animation: fadeInUp 0.5s ease-out both;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        .team-card:hover {
          transform: translateY(-0.75rem);
          box-shadow: 0 25px 35px -12px rgba(0, 0, 0, 0.2);
        }
        
        /* Image Wrapper - Improved */
        .team-card-image-wrapper {
          position: relative;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 2rem 1.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 320px;
          flex-shrink: 0;
        }
        
        /* Image Box with 16px border radius */
        .team-image-box {
          width: 100%;
          max-width: 260px;
          background: white;
          border-radius: 16px;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;
        }
        
        [data-theme="dark"] .team-image-box {
          background: #2d2d3d;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
        }
        
        .team-card:hover .team-image-box {
          transform: scale(1.02);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
        }
        
        .team-card-image {
          width: 100%;
          max-width: 220px;
          height: auto;
          max-height: 240px;
          object-fit: contain;
          transition: transform 0.5s ease;
          border-radius: 8px;
        }
        
        .team-card:hover .team-card-image {
          transform: scale(1.05);
        }
        
        .team-card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.1));
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .team-card:hover .team-card-overlay {
          opacity: 1;
        }
        
        .team-card-badge {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: rgba(255,255,255,0.95);
          backdrop-filter: blur(5px);
          border-radius: 9999px;
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          opacity: 0;
          transform: translateX(20px);
          transition: all 0.3s ease;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        .team-card:hover .team-card-badge {
          opacity: 1;
          transform: translateX(0);
        }
        
        .team-card-content {
          padding: 1.5rem;
          text-align: center;
          background: var(--team-card-bg-light);
          flex: 1;
          display: flex;
          flex-direction: column;
          transition: background 0.3s ease;
        }
        .team-card-name {
          font-size: 1.1rem;
          font-weight: bold;
          color: var(--team-text-primary-light);
          margin-bottom: 0.25rem;
          transition: color 0.3s ease;
        }
        .team-card-designation {
          background: linear-gradient(135deg, #4f46e5, #ec4899);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: 600;
          font-size: 0.75rem;
          margin-bottom: 0.75rem;
        }
        .team-card-bio-full {
          color: var(--team-text-secondary-light);
          font-size: 0.75rem;
          line-height: 1.5;
          text-align: left;
          max-height: 250px;
          overflow-y: auto;
          padding-right: 0.5rem;
          transition: color 0.3s ease;
        }
        .team-card-bio-full::-webkit-scrollbar {
          width: 4px;
        }
        .team-card-bio-full::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        [data-theme="dark"] .team-card-bio-full::-webkit-scrollbar-track {
          background: #2d2d3d;
        }
        .team-card-bio-full::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, #4f46e5, #ec4899);
          border-radius: 10px;
        }
        .bio-paragraph {
          margin-bottom: 0.75rem;
        }
        .bio-paragraph:last-child {
          margin-bottom: 0;
        }
        .team-card-line {
          margin-top: 1rem;
          width: 3rem;
          height: 0.125rem;
          background: linear-gradient(to right, #4f46e5, #ec4899);
          margin-left: auto;
          margin-right: auto;
          border-radius: 9999px;
          transition: width 0.3s ease;
          flex-shrink: 0;
        }
        .team-card:hover .team-card-line {
          width: 4rem;
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translate(0, 0);
          }
          50% {
            transform: translate(20px, -20px);
          }
        }

        /* Responsive */
        @media (max-width: 1200px) {
          .team-grid-4cols {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (max-width: 992px) {
          .team-grid-4cols {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 640px) {
          .team-hero-title {
            font-size: 2rem;
          }
          .team-hero-subtitle {
            font-size: 1rem;
          }
          .team-header-title {
            font-size: 1.75rem;
          }
          .team-grid-4cols {
            grid-template-columns: 1fr;
          }
          .team-card-image-wrapper {
            min-height: 280px;
          }
          .team-image-box {
            max-width: 220px;
          }
          .team-card-image {
            max-width: 180px;
            max-height: 200px;
          }
        }
      `}</style>
    </>
  );
};

export default OurMember;


